import type React from 'react';
import { Page as Component } from '~/components/specifics/admin/Page';

export const Page: React.FC = () => <Component />;
